import styled from 'styled-components'

export const HeroSectionView = styled.section`
  display: grid;
  width: 100%;
  height: 100vh;
  color: #ffffff;
  background-color: #041E42;
  position: relative;
  /* top: 0;
  left: 0; 
  z-index: -1; */
  overflow: hidden;

  video {
    grid-area: 1/1;
    object-fit: cover;
    width: 100vw;
    height: 100vh;
  }
`

export const HeroContentWrapper = styled.header`
  display: grid;
  grid-area: 1/1;
  position: relative;
  place-items: center;
`

export const HeroContent = styled.div`
  width: 100%;
  padding: 0 36px;
  max-width: 920px;
  margin: 0 auto;
  text-align: center;

  @media screen and (min-width: 768px) {
    text-align: left;
  }

  @media screen and (min-width: 992px) {
    padding: 0;
  }
`

export const Activity = styled.p`
  font-size: 1.75rem;
  margin-bottom: 10px;
  opacity: 0;
`

export const Location = styled.p`
  font-family: 'Sica', sans-serif;
  font-size: 1.1875rem;
  opacity: 0;
`

export const HeadlineDetails = styled.div`
  margin-bottom: 32px;

  @media screen and (min-width: 992px) {
    padding-left: 130px;
  }
`;

export const Title = styled.h1`
  font-size: 3.125rem;
  line-height: 1;
  font-weight: normal;
  opacity: 0;

  @media screen and (min-width: 768px) {
    font-size: 3.75rem;
  }
`

export const Content = styled.div`
  background: ${props => props.transparent ? '#ffffff00' : '#ffffff'};
  color: #15405C;
`

export const ImageSectionView = styled.section`
  display: flex;
  flex-direction: column;
  max-width: ${props => props?.width || 920}px;
  width: 100%;
  margin: auto;
  padding: 0 36px 90px;
  background: #ffffff;

  img, picture {
    width: 100%;
    line-height: 0;
  }

  &:last-of-type{
    margin: 0 auto;
  }

  @media screen and (min-width: 768px) {
    padding: 0 36px 50px;
    flex-direction: row;

    picture {
      width: 50%;
    }
  }

  @media screen and (min-width: 992px) {
    padding: 0 0 120px;
  }
`

export const ImageLeftSection = styled(ImageSectionView)`
  @media screen and (min-width: 768px) {

    figure {
      height: 700px;
      order: 1;
    }

    .gatsby-image-wrapper {
      height: 800px;
    }
  }
`

export const ImageRightSection = styled(ImageSectionView)`
  @media screen and (min-width: 768px) {

    figure {
      height: 700px;
      order: 2;
    }

    .gatsby-image-wrapper {
      height: 800px;
    }
  }
`

export const ImageSwitchSection = styled(ImageSectionView)`

  ${({mobilePadding}) => mobilePadding && 'padding: 90px 36px ;'}
  @media screen and (min-width: 768px) {
    padding: 0;
    figure {
      height: 700px;
      order: ${props => props?.isEven ? 2 : 1};
    }

    .gatsby-image-wrapper {
      height: 800px;
    }
  }
`

export const ImageSectionPicture = styled.figure`
  overflow: hidden;
  will-change: transform, opacity;
`;

export const ImageSectionText = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-shrink: 0;
  padding: 0;

  @media screen and (min-width: 768px) {
    width: 50%;
    padding: ${props => props?.isEven ? '0 64px 0 0' : '0 0 0 64px' };
    margin: 0;
    order: ${props => props?.isEven ? 1 : 2};
  }
`

export const ImageSectionTitle = styled.h2`
  margin: .825rem 0 2rem;
  line-height: 1;
  font-weight: 100;
  font-size: 35px;
`

export const ImageSectionParagraph = styled.p`
  font-family: 'Sica', sans-serif;
  font-size: 18px;
  line-height: 1.5;
  white-space: pre-wrap;
`

export const CenteredImageWrapper = styled.figure`
  overflow: hidden;

  @media screen and (min-width: 768px) {
    height: 700px;
  }
`;

export const CenteredImage = styled.div`
  display: block;
  text-align: center;
  margin: auto;
  padding: 0 36px 102px;

  @media screen and (min-width: 992px) {
    padding: 160px 0 128px;
  }
`

export const WhiteBG = styled.div`
  background-color: #fff;
`;

export const FullWidthSectionView = styled.section`
  width: 100%;
  /* margin: 100vh auto 0; */
  padding: ${props => props.margin || '0'};
  position: relative;
  background-color: transparent;

  .gatsby-image-wrapper {
    min-height: 100vh;
    will-change: transform;
  }
`

export const FullWidthSectionNoTopMargin = styled(FullWidthSectionView)`
  margin: auto;
  min-height: 100vh;
`;

export const CustomerJourneySection = styled(FullWidthSectionNoTopMargin)`
  min-height: 200vh;

  & div, p {
    color: #ffffff;
  }

  .gatsby-image-wrapper {
    min-height: 200vh;
  }

  @media screen and (min-width: 768px) {
    min-height: 100vh;

    .gatsby-image-wrapper {
      min-height: 100vh;
    }
  }
`
export const StayLongerSection = styled.section`
  background-color: #ffffff;
  padding: 2rem 0;
`

export const EventDatesText = styled.p`
  font-family: 'Sica', sans-serif;
  position: fixed;
  left: 10px;
  bottom: 10px;
  font-size: 1.1875rem;
  color: #041E42;
  z-index: 300;
`